/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						this.querySelectorAll('.lazyload').forEach((image) => {
							lazySizes.loader.unveil(image);
						});
					}

					this.classList.add('product-recommendations--loaded');
                  // ===================
                    const quantitySelectors = document.querySelectorAll('.quantity-selector');
                    quantitySelectors.forEach(selector => {
                      const minusBtn = selector.querySelector('.minus');
                      const plusBtn = selector.querySelector('.plus');
                      const input = selector.querySelector('.quantity-input');
                      
                      minusBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        let value = parseInt(input.value);
                        if (value > parseInt(input.min)) {
                          input.value = value - 1;
                        }
                        triggerChangeEvent(input);
                      });
                      
                      plusBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        let value = parseInt(input.value);
                        if (value < parseInt(input.max)) {
                          input.value = value + 1;
                        }
                        triggerChangeEvent(input);
                      });
                      
                      // Optional: Validate input when user types manually
                      input.addEventListener('change', (e) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        let value = parseInt(input.value);
                        if (isNaN(value) || value < parseInt(input.min)) {
                          input.value = input.min;
                        } else if (value > parseInt(input.max)) {
                          input.value = input.max;
                        }
                      });
                    });
                    
                    function triggerChangeEvent(element) {
                      const event = new Event('change', { bubbles: true });
                      element.dispatchEvent(event);
                      }

                     const addToCartButtons = document.querySelectorAll('.custom-add-pro');
                        addToCartButtons.forEach(button => {
                          button.addEventListener('click', function(e) {
                            e.preventDefault();
                            
                            if (this.disabled) {
                              return;
                            }
                            
                            const variantId = this.getAttribute('data-product-id');
                            if (!variantId) {
                              console.error('No variant ID found on button.');
                              return;
                            }
                        
                            this.classList.add('loading');
                            this.setAttribute('aria-disabled', true);
                      
                            const quantity = 1;
                        
                            const config = {
                              method: 'POST',
                              headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/javascript'
                              }
                            };
                        
                            let formData = new FormData();
                            formData.append('id', variantId);
                            formData.append('quantity', quantity);
                            formData.append('sections', getSectionsToRender().map((section) => section.section));
                            formData.append('sections_url', window.location.pathname);
                            config.body = formData;
                        
                            fetch(`${theme.routes.cart_add_url}`, config)
                              .then((response) => response.json())
                              .then((response) => {
                                if (response.status) {
                                  return;
                                }
                                renderContents(response);
                                console.log("success", response);
                                dispatchCustomEvent('cart:item-added', {
                                  product: response.hasOwnProperty('items') ? response.items[0] : response
                                });
                              })
                              .catch((e) => {
                                console.error(e);
                              })
                              .finally(() => {
                                this.classList.remove('loading');
                                this.removeAttribute('aria-disabled');
                              });
                          });
                        });
                        
                        function getSectionsToRender() {
                          return [
                            {
                              id: 'Cart',
                              section: 'main-cart',
                              selector: '.thb-cart-form'
                            },
                            {
                              id: 'Cart-Drawer',
                              section: 'cart-drawer',
                              selector: '.cart-drawer'
                            },
                            {
                              id: 'cart-drawer-toggle',
                              section: 'cart-bubble',
                              selector: '.thb-secondary-area--item-count'
                            },
                            {
                              id: 'cart-drawer-toggle',
                              section: 'cart-bubble',
                              selector: '.thb-secondary-area--item-amount'
                            }
                          ];
                        }
                        
                        function renderContents(parsedState) {
                          getSectionsToRender().forEach((section) => {
                            if (!document.getElementById(section.id)) {
                              return;
                            }
                            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                            elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                          });
                        
                          if (document.getElementById('Cart-Drawer')) {
                            document.getElementById('Cart-Drawer').open();
                            if (document.getElementById('Cart-Drawer').removeProductEvent) {
                              document.getElementById('Cart-Drawer').removeProductEvent();
                            }
                          }
                        }
                        
                        function getSectionInnerHTML(html, selector = '.shopify-section') {
                          return new DOMParser()
                            .parseFromString(html, 'text/html')
                            .querySelector(selector)?.innerHTML;
                        }
                        
                        function dispatchCustomEvent(name, detail = {}) {
                          const event = new CustomEvent(name, { detail });
                          document.dispatchEvent(event);
                        }
                  // =======================
				})
				.catch(e => {
					console.error(e);
				});
		}
		connectedCallback() {
			this.fetchProducts();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}

